document.addEventListener('DOMContentLoaded',()=>{
  const subscriptionOnly=Boolean(document.querySelector('[data-subscription-only="true"]'));
  const formatMoney=(cents,currency)=>new Intl.NumberFormat(undefined,{style:'currency',currency:currency||'USD'}).format((Number(cents)||0)/100);
  document.querySelectorAll('[data-cart-total-calculator]').forEach(calculator=>{
    const form=calculator.closest('.product-detail')?.querySelector('.product-form');
    const variantSelect=form?.querySelector('[data-variant-select]');
    const submit=form?.querySelector('[data-add-to-cart]');
    const currency=calculator.dataset.currency||'USD';
    const unitOutput=calculator.querySelector('[data-live-unit-price]');
    const totalOutput=calculator.querySelector('[data-live-total]');
    const quantityOutput=calculator.querySelector('[data-live-quantity]');
    const stockMessage=calculator.querySelector('[data-inventory-limit-message]');
    const quantityInput=form?.querySelector('input[name="quantity"]');
    let cartQuantities={};

    if(subscriptionOnly&&calculator.dataset.cartTotalCalculator==='item') calculator.hidden=true;

    const variantState=()=>{
      const option=variantSelect?.options[variantSelect.selectedIndex];
      const id=String(option?.value||form?.querySelector('[name="id"]')?.value||quantityInput?.dataset.variantId||'');
      const managed=option?option.dataset.inventoryManaged==='true':quantityInput?.dataset.inventoryManaged==='true';
      const policy=option?.dataset.inventoryPolicy||quantityInput?.dataset.inventoryPolicy||'';
      const inventory=Number(option?.dataset.inventoryQuantity??quantityInput?.dataset.inventoryQuantity);
      const limited=managed&&policy==='deny'&&Number.isFinite(inventory);
      const alreadyInCart=Number(cartQuantities[id]||0);
      const available=option?option.dataset.available!=='false':quantityInput?.dataset.available!=='false';
      return {id,available,limited,inventory,alreadyInCart,remaining:limited?Math.max(0,inventory-alreadyInCart):Infinity};
    };

    const update=()=>{
      if(variantSelect){
        const option=variantSelect.options[variantSelect.selectedIndex];
        if(option?.dataset.priceCents) calculator.dataset.unitPrice=option.dataset.priceCents;
      }
      const state=variantState();
      const unitCents=Number(calculator.dataset.unitPrice)||0;
      let units=1;
      let displayQuantity='1 item';
      if(calculator.dataset.cartTotalCalculator==='quarter'){
        const yardInput=calculator.querySelector('[data-quarter-input]');
        let yards=Math.max(.25,Math.round((Number.parseFloat(yardInput?.value)||.25)*4)/4);
        units=Math.round(yards*4);
        if(state.limited&&units>state.remaining){units=state.remaining;yards=units/4;if(yardInput)yardInput.value=String(yards);}
        if(yardInput) yardInput.value=yards.toFixed(2);
        if(quantityInput) quantityInput.value=String(units);
        const lengthOutput=calculator.querySelector('[data-quarter-length]');
        displayQuantity=yards.toFixed(2)+(yards===1?' yard':' yards');
        if(lengthOutput) lengthOutput.textContent=displayQuantity;
      }else{
        units=Math.max(1,Math.round(Number(quantityInput?.value)||1));
        if(state.limited&&units>state.remaining) units=Math.max(1,state.remaining);
        if(quantityInput){
          quantityInput.value=String(units);
          if(state.limited) quantityInput.max=String(state.remaining);
          else quantityInput.removeAttribute('max');
        }
        displayQuantity=units+' '+(units===1?'item':'items');
      }
      const total=formatMoney(unitCents*units,currency);
      if(unitOutput) unitOutput.textContent=formatMoney(unitCents,currency);
      if(totalOutput) totalOutput.textContent=total;
      if(quantityOutput) quantityOutput.textContent=displayQuantity;
      if(state.limited&&stockMessage){
        stockMessage.textContent=state.remaining>0
          ? 'Only '+state.inventory+' available; '+state.remaining+' can still be added because '+state.alreadyInCart+' '+(state.alreadyInCart===1?'is':'are')+' already in your cart.'
          : 'All '+state.inventory+' available '+(state.inventory===1?'copy is':'copies are')+' already in your cart.';
      }
      if(submit){
        submit.disabled=!state.available||(state.limited&&state.remaining<1);
        if(!state.available) submit.textContent='Sold out';
        else if(submit.disabled) submit.textContent='Maximum available quantity is already in cart';
        else submit.textContent=subscriptionOnly?'Add subscription to cart':'Add to cart · '+total;
      }
      calculator.querySelectorAll('[data-change="plus"],[data-quarter-change="plus"]').forEach(button=>{
        button.disabled=state.limited&&units>=state.remaining;
        button.setAttribute('aria-disabled',String(button.disabled));
      });
    };

    const refreshCart=async()=>{
      try{
        const response=await fetch('/cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
        if(!response.ok) return;
        const cart=await response.json();
        cartQuantities={};
        (cart.items||[]).forEach(item=>{cartQuantities[String(item.variant_id)]=(cartQuantities[String(item.variant_id)]||0)+Number(item.quantity||0);});
      }catch(error){}
      update();
    };

    calculator.querySelectorAll('input').forEach(input=>{
      input.addEventListener('input',update);
      input.addEventListener('change',update);
    });
    calculator.querySelectorAll('[data-change]').forEach(button=>button.addEventListener('click',()=>window.setTimeout(update,0)));
    calculator.querySelectorAll('[data-quarter-change]').forEach(button=>button.addEventListener('click',()=>{
      const input=calculator.querySelector('[data-quarter-input]');
      input.value=String((Number.parseFloat(input.value)||0.25)+(button.dataset.quarterChange==='plus'?0.25:-0.25));
      update();
    }));
    variantSelect?.addEventListener('change',()=>{window.setTimeout(update,0);refreshCart();});
    let checkingStock=false;
    const cartStatus=document.createElement('p');
    cartStatus.setAttribute('role','status');
    cartStatus.setAttribute('aria-live','polite');
    cartStatus.hidden=true;
    submit?.insertAdjacentElement('afterend',cartStatus);
    form?.addEventListener('submit',async event=>{
      event.preventDefault();
      if(checkingStock){event.preventDefault();return;}
      update();
      const state=variantState();
      if(!state.available){event.preventDefault();return;}
      const requested=Math.max(1,Math.round(Number(quantityInput?.value)||1));
      const formData=new FormData(form);
      formData.set('quantity',String(requested));
      checkingStock=true;
      cartStatus.hidden=true;
      if(submit){submit.disabled=true;submit.setAttribute('aria-busy','true');}
      try{
        await refreshCart();
        const fresh=variantState();
        if(fresh.id!==state.id||!fresh.available||(fresh.limited&&(fresh.remaining<1||requested>fresh.remaining))){
          update();
          cartStatus.textContent='The available quantity changed. Please review your quantity and try again.';
          cartStatus.hidden=false;
          quantityInput?.focus();
          return;
        }
        const root=window.Shopify?.routes?.root||'/';
        const response=await fetch(root+'cart/add.js',{method:'POST',credentials:'same-origin',headers:{Accept:'application/json'},body:formData});
        const result=await response.json();
        if(!response.ok) throw new Error(result.description||result.message||'Unable to add this item. Please review your cart before trying again.');
        cartStatus.textContent='Added to your cart. ';
        const viewCart=document.createElement('a');
        viewCart.href=root+'cart';
        viewCart.textContent='View cart and checkout';
        cartStatus.appendChild(viewCart);
        cartStatus.hidden=false;
        await refreshCart();
        try{
          const cartResponse=await fetch(root+'cart.js',{credentials:'same-origin',cache:'no-store',headers:{Accept:'application/json'}});
          if(cartResponse.ok){
            const cart=await cartResponse.json();
            document.querySelectorAll('.header-actions .cart span,.hues-mobile-cart span').forEach(count=>{count.textContent=String(cart.item_count);});
            document.querySelectorAll('.hues-mobile-cart').forEach(link=>{link.setAttribute('aria-label','Cart, '+cart.item_count+' items');});
          }
        }catch(error){}
      }catch(error){
        cartStatus.textContent=error.message||'Unable to confirm the addition. Please check your cart before trying again.';
        cartStatus.hidden=false;
      }finally{
        checkingStock=false;
        if(submit) submit.removeAttribute('aria-busy');
        update();
      }
    });
    update();
    refreshCart();
  });
  if(subscriptionOnly){
    const standardPrice=document.querySelector('[data-product-price]');
    if(standardPrice) standardPrice.hidden=true;
  }
});

